export {default as ListartPeticiones} from './Listar';
export { default as CrearPeticiones } from './Crear';
export { default as DetallePetciones} from './Detalle';
export { default as PeticionesPendientes} from './Pendientes';